















































import {Component, Vue} from 'vue-property-decorator';
import {User} from '@/oauth/User';
import {Pagination} from '@/oauth/Pagination';
import {Page} from '@/oauth/Page';
import UserControl from '@/oauth/UserControl.vue';
import {UserDto} from '@/oauth/UserDto';

@Component({
  components: {UserControl},
})
export default class MultiPageTable extends Vue {
  private popUp = false;
  private loading = false;
  private userControl = false;
  private editingUser = new User();
  private tableFilter = {username: ''};
  private data: User[] = [];
  private columns: QTableColumn[] = [{
    name: 'id',
    label: '用户id',
    field: 'id',
  }, {
    name: 'username',
    label: '用户名',
    field: 'username',
  },
    {
      name: '修改',
      label: '修改',
      field: '',
    },
    // , {
    //     name: 'authorities',
    //     label: '用户角色',
    //     field: (row: User): string => {
    //         if (row.authorities.length !== 0) {
    //             return row.authorities[0].authority;
    //         }
    //         return '无';
    //     },
    // }
  ];
  private pagination: Pagination = {
    rowsPerPage: 5,
    page: 1,
  };

  private hint() {
    this.$q.dialog({message: 'hehe'});
  }

  private showUserControl() {
    this.userControl = true;
    this.editingUser = new User();
  }

  private editUser(u: User) {
    this.userControl = true;
    this.editingUser = u;
  }

  private async deleteUser(u: User) {
    if (typeof u.id !== 'undefined') {
      await UserDto.delete(u.id);
      await this.getAll();
    }
  }


  private handleSubmit() {
    this.editingUser = new User();
    this.userControl = false;
    this.getAll();
  }

  private async getAll(p?: QTableRequestOption) {
    this.loading = true;
    let iUserPage: Page<User>;

    try {
      if (typeof p !== 'undefined') {

        this.pagination = p.pagination;
      }
      iUserPage = await UserDto.getAll(this.pagination, this.tableFilter);
      this.data = iUserPage.content;
      const pPage: Pagination = Page.of(iUserPage).getPagination();
      if (typeof p !== 'undefined') {
        pPage.rowsPerPage = p.pagination.rowsPerPage;
        pPage.page = p.pagination.page;
      }
      this.pagination = pPage;
    } catch (e) {
      this.$q.notify({message: '获取数据失败!' + e, color: 'red'});
    }
    this.loading = false;
  }

  private async getAllByDate(date: { date: string }) {
    this.loading = true;
    const iUserPage = await UserDto.getAllByDate(this.pagination.rowsPerPage, this.pagination.page, date);
    this.data = iUserPage.content.map((iu) => User.of(iu));
    this.pagination = Page.of(iUserPage).getPagination();
    this.loading = false;
  }

  private mounted() {
    this.getAll();
    this.$root.$on('UserAdded', this.getAll);
  }
}
